import { useHistoryChange } from '@app/components-legacy/Router/hooks'
import { useStores, useAppRouter, useAppTranslator } from '@app/hooks'
import { isNotFalsy } from '@libs/isDefined'

/***
 * Update title at each history change.
 */
export function useTitleBindingsOnHistory() {
  const { storeLayout } = useStores()

  const router = useAppRouter()
  const translate = useAppTranslator({ namespaces: ['RouteNames.Pages'] })

  function updateDocumentTitle() {
    const routeName = router.getCurrentRouteName()

    if (!routeName) {
      return
    }

    const routeNameTranslated = translate(routeName)
    document.title = [storeLayout.getProductName(), routeNameTranslated]
      .filter(isNotFalsy)
      .join(' - ')
  }

  useHistoryChange({
    onHistoryChange: updateDocumentTitle
  })

  // update title at first load
  updateDocumentTitle()
}
